import {useContext} from 'react';
import {AnalyticsContext} from '../components/AnalyticsContext';

const useAnalytics = () => useContext(AnalyticsContext);

export default useAnalytics;
